module.exports = __webpack_public_path__ + "img/login-v2.c90b9dcf.svg";